import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-container',
  templateUrl: './skeleton-container.component.html',
  styleUrls: ['./skeleton-container.component.sass'],
})
export class SkeletonContainerComponent {
  @Input() errorThrown = false;
  @Input() showBanner = true;
  @Input() errorMessage = '';
  @Input() errorContainerHeight = '500px';

  constructor() {}
}
